import React from 'react';
import { Link } from 'react-router-dom';
import DataUse from './DataUse';
import { useTranslation } from 'react-i18next';

export default function ({ setFeedbackUse, clientName, clientEmail, clientPhone, clientPrivacy, isClientInfo = true, privacyText = '' }) { // [TODO] function needs name
	const { t } = useTranslation('survey');

	const closefeedbackPop = () => {
		setFeedbackUse(false);
		// const IntroHeader = document.getElementsByClassName('intro_header')[0];
		// IntroHeader.style.display = 'block';
		const element = document.getElementsByClassName('modal')[0];
		if (element) {
			element.classList.remove('modal-popup');
			// focus on the start button
			document.querySelector('.survey__cta button').focus();
		}
	};

	// Email validation from https://stackoverflow.com/a/46181
	const validateEmail = (email) => {
		return email.match(
			// eslint-disable-next-line
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
	};

	// Hide the popup on escape press.
	document.addEventListener('keyup', keyupCheck);
	function keyupCheck (e) {
		var key = e.keyCode || e.which;
		if (key === 27) { // [Escape]
			if (document.querySelector('.popup')) {
				closefeedbackPop();
			}
		}
	}

	// Check the email's valid, set to null if not
	if (clientEmail && !validateEmail(clientEmail)) {
		clientEmail = null;
	}

	if (clientPrivacy) {
		clientPrivacy = clientPrivacy.replace('https://', '');
		clientPrivacy = clientPrivacy.replace('http://', '');
	} else {
		// Cavendish by default.
		clientPrivacy = 'cavendishconsulting.com/data-protection/';
	}

	if (
		!clientEmail &&
		!clientPhone &&
		!clientPrivacy
	) {
		isClientInfo = false;
	} else {
		// [TODO] create this string here as the variances are quite complex.
		// Might need to change as it's using `dangerouslySetInnerHTML` to output.
		// But significantly cuts repetition.
		privacyText = ' ' + t('survey.feedback.privacy-text');
		if (clientPrivacy) {
			privacyText = privacyText + t('survey.feedback.please-visit') + '<a href="https://' + clientPrivacy + '" rel="noopener noreferrer"><b class="popup__url">' + clientPrivacy + '</b></a>';
		}
		if (clientPhone) {
			privacyText = privacyText + t('survey.feedback.phone-contact') + '<a class="internal" href="tel:' + clientPhone + '"><b>' + clientPhone + '</b></a>';
		}
		if (clientEmail) {
			privacyText = privacyText + t('survey.feedback.email-contact') + '<a class="internal" href="mailto:' + clientEmail + '"><b class="popup__url"">' + clientEmail + '</b></a>';
		}
		privacyText = privacyText + '.';
	}

	return (
		<div className="popup">
			<button className="close_popup plain" onClick={closefeedbackPop}>{t('survey.generic.Close')}</button>
			<div className="popup_content">
				<DataUse clientName={clientName}/>
				<div className='data_protection'>
					<h2>{t('survey.feedback.data-protection')}</h2>
					<p>{t('survey.feedback.process')} <span dangerouslySetInnerHTML={{ __html: privacyText }} /></p>
					<p>{t('survey.feedback.min-age')}</p>
				</div>
			</div>
		</div>
	);
}
